/* unplugin-vue-components disabled */import { render } from "./BaseDialog.vue?vue&type=template&id=e1559f06"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=e1559f06&lang=less"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__